export default __webpack_public_path__ + "static/workflow-import-aa5fa3097e9542a6197d8f3e5aad63f8.png";